var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrfRoadmapMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2101.546,
    height: 587.718,
    viewBox: "0 0 2101.546 587.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5281",
    "data-name": "Group 5281",
    transform: "translate(-9865.276 -3907)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    x2: 2095.9,
    transform: "translate(9868.1 4207.979)",
    fill: "none",
    stroke: "#d8d8d8",
    strokeLinecap: "round",
    strokeWidth: 5.646
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-12",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(9910.6 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    x1: 279.5,
    transform: "translate(9921.149 4204.579) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(9927.75 4201.979) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "The_Ultimate_Family_Disaster_Plan",
    "data-name": "The Ultimate Family Disaster Plan",
    transform: "translate(9944.066 4266.718)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The Ultimate Family Disaster Plan")), /*#__PURE__*/React.createElement("text", {
    id: "You_can_t_put_a_price_on_this._A_disaster_can_happen_at",
    "data-name": "You can\\u2019t put a price on this. A disaster can happen at",
    transform: "translate(9944.066 4294.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "You can\u2019t put a price on this. A disaster can happen at")), /*#__PURE__*/React.createElement("text", {
    id: "any_time_including_years_after_the_plan_is_developed_",
    "data-name": "any time including years after the plan is developed,",
    transform: "translate(9944.066 4318.052)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "any time including years after the plan is developed,")), /*#__PURE__*/React.createElement("text", {
    id: "but_having_access_to_your_plan_will_ensure_that",
    "data-name": "but having access to your plan will ensure that",
    transform: "translate(9944.066 4341.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "but having access to your plan will ensure that")), /*#__PURE__*/React.createElement("text", {
    id: "everyone_knows_where_to_meet_whether_in-town_or_out-",
    "data-name": "everyone knows where to meet whether in-town or out-",
    transform: "translate(9944.066 4364.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "everyone knows where to meet whether in-town or out-")), /*#__PURE__*/React.createElement("text", {
    id: "of-town_based_on_the_meeting_locations_you_set_PRE-",
    "data-name": "of-town based on the meeting locations you set PRE-",
    transform: "translate(9944.066 4388.052)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of-town based on the meeting locations you set PRE-")), /*#__PURE__*/React.createElement("text", {
    id: "DISASTER_Locked-in_via_Google_Maps_._They_simply",
    "data-name": "DISASTER (Locked-in via Google Maps). They simply",
    transform: "translate(9944.066 4411.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DISASTER (Locked-in via Google Maps). They simply")), /*#__PURE__*/React.createElement("text", {
    id: "log_on_to_the_plan_via_their_smart_phone_or_tablet_and",
    "data-name": "log on to the plan via their smart phone or tablet, and",
    transform: "translate(9944.066 4434.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "log on to the plan via their smart phone or tablet, and")), /*#__PURE__*/React.createElement("text", {
    id: "view_the_different_meeting_locations_and_other",
    "data-name": "view the different meeting locations and other",
    transform: "translate(9944.066 4458.052)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "view the different meeting locations and other")), /*#__PURE__*/React.createElement("text", {
    id: "important_instructions.",
    "data-name": "important instructions.",
    transform: "translate(9944.066 4481.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "important instructions.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-13",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(9973.796 4197.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-2",
    x2: 304.7,
    transform: "translate(9984.216 3907) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-2",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(9990.815 4201.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "It_comes_with_a_MYREDFOLDER_App_",
    "data-name": "It comes with a MYREDFOLDER\\xAE App!",
    transform: "translate(10007.584 3925.079)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "It comes with a MYREDFOLDER\xAE App!")), /*#__PURE__*/React.createElement("text", {
    id: "This_App_gives_the_App_owner_the_ability_to_locate_and",
    "data-name": "This App gives the App owner the ability to locate and",
    transform: "translate(10007.584 3953.079)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "This App gives the App owner the ability to locate and")), /*#__PURE__*/React.createElement("text", {
    id: "track_ALL_family_members_in_the_event_of_a_Disaster_as",
    "data-name": "track ALL family members in the event of a Disaster as",
    transform: "translate(10007.584 3976.413)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "track ALL family members in the event of a Disaster as")), /*#__PURE__*/React.createElement("text", {
    id: "well_as_to_send_PRE-WRITTEN_messages_to",
    "data-name": "well as to send \\u201CPRE-WRITTEN\\u201D messages to",
    transform: "translate(10007.584 3999.746)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "well as to send \u201CPRE-WRITTEN\u201D messages to")), /*#__PURE__*/React.createElement("text", {
    id: "everyone_s_phone_with_the_press_of_a_button._It_is_likely",
    "data-name": "everyone\\u2019s phone with the press of a button. It is likely",
    transform: "translate(10007.584 4023.079)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "everyone\u2019s phone with the press of a button. It is likely")), /*#__PURE__*/React.createElement("text", {
    id: "that_the_internet_and_the_phone_system_will_be",
    "data-name": "that the internet and the phone system will be",
    transform: "translate(10007.584 4046.413)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "that the internet and the phone system will be")), /*#__PURE__*/React.createElement("text", {
    id: "overwhelmed_as_a_disaster_intensifies_this_is_why_the",
    "data-name": "overwhelmed as a disaster intensifies, this is why the",
    transform: "translate(10007.584 4069.746)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "overwhelmed as a disaster intensifies, this is why the")), /*#__PURE__*/React.createElement("text", {
    id: "APP_owner_immediately_activates_the_plan_at_the_onset",
    "data-name": "APP owner immediately activates the plan at the onset",
    transform: "translate(10007.584 4093.079)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "APP owner immediately activates the plan at the onset")), /*#__PURE__*/React.createElement("text", {
    id: "of_the_disaster._All_members_will_know_where_to_meet",
    "data-name": "of the disaster. All members will know where to meet",
    transform: "translate(10007.584 4116.413)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of the disaster. All members will know where to meet")), /*#__PURE__*/React.createElement("text", {
    id: "based_on_the_PRE-RECORDED_message_instructions",
    "data-name": "based on the PRE-RECORDED message/instructions",
    transform: "translate(10007.584 4139.746)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "based on the PRE-RECORDED message/instructions")), /*#__PURE__*/React.createElement("text", {
    id: "that_was_sent_to_them.",
    "data-name": "that was sent to them.",
    transform: "translate(10007.584 4163.079)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "that was sent to them.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-14",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(10359.297 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-3",
    x1: 245.3,
    transform: "translate(10369.767 4204.579) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-3",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(10376.367 4201.979) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "All_Social_Media_User",
    "data-name": "All Social Media User",
    transform: "translate(10393.09 4266.718)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "All Social Media User")), /*#__PURE__*/React.createElement("text", {
    id: "Names_and_Passwords",
    "data-name": "Names and Passwords",
    transform: "translate(10393.09 4291.606)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Names and Passwords")), /*#__PURE__*/React.createElement("text", {
    id: "so_the_account_can_be",
    "data-name": "so the account can be",
    transform: "translate(10393.09 4316.496)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "so the account can be")), /*#__PURE__*/React.createElement("text", {
    id: "shut_down_in_the_event",
    "data-name": "shut down in the event",
    transform: "translate(10393.09 4341.385)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "shut down in the event")), /*#__PURE__*/React.createElement("text", {
    id: "of_an_untimely_death.",
    "data-name": "of an untimely death.",
    transform: "translate(10393.09 4366.273)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of an untimely death.")), /*#__PURE__*/React.createElement("text", {
    id: "This_is_critical_as_it_is_rarely",
    "data-name": "This is critical as it is rarely",
    transform: "translate(10393.09 4396.996)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "This is critical as it is rarely")), /*#__PURE__*/React.createElement("text", {
    id: "thought_about_until_it_s_too",
    "data-name": "thought about until it\\u2019s too",
    transform: "translate(10393.09 4420.329)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "thought about until it\u2019s too")), /*#__PURE__*/React.createElement("text", {
    id: "late.",
    transform: "translate(10393.09 4443.662)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "late.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-15",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(10437.901 4197.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-4",
    x2: 213.7,
    transform: "translate(10448.432 3998) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-4",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(10455.032 4201.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Bank_Account_Numbers",
    "data-name": "Bank Account Numbers",
    transform: "translate(10471.5 4014.524)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bank Account Numbers")), /*#__PURE__*/React.createElement("text", {
    id: "and_Access_Codes.",
    "data-name": "and Access Codes.",
    transform: "translate(10471.5 4039.414)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and Access Codes.")), /*#__PURE__*/React.createElement("text", {
    id: "In_the_event_of_a_lost_or_stolen",
    "data-name": "In the event of a lost or stolen",
    transform: "translate(10471.5 4070.524)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In the event of a lost or stolen")), /*#__PURE__*/React.createElement("text", {
    id: "purse_or_the_untimely_death_of_a",
    "data-name": "purse or the untimely death of a",
    transform: "translate(10471.5 4093.858)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "purse or the untimely death of a")), /*#__PURE__*/React.createElement("text", {
    id: "loved_one_quick_access_to_the",
    "data-name": "loved one; quick access to the",
    transform: "translate(10471.5 4117.191)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "loved one; quick access to the")), /*#__PURE__*/React.createElement("text", {
    id: "unknown_account_or_password",
    "data-name": "unknown account or password",
    transform: "translate(10471.5 4140.524)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "unknown account or password")), /*#__PURE__*/React.createElement("text", {
    id: "protected_accounts_is_a_must.",
    "data-name": "protected accounts is a must.",
    transform: "translate(10471.5 4163.858)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "protected accounts is a must.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-16",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(10641.399 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-5",
    y1: 264.8,
    transform: "translate(10651.92 4204.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-5",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(10645.32 4202.029)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Location_of_Stocks_Bonds_",
    "data-name": "Location of Stocks, Bonds,",
    transform: "translate(10675.281 4266.718)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Location of Stocks, Bonds,")), /*#__PURE__*/React.createElement("text", {
    id: "Portfolios_Loan_Paper_Work_",
    "data-name": "Portfolios, Loan Paper Work,",
    transform: "translate(10675.281 4291.606)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Portfolios, Loan Paper Work,")), /*#__PURE__*/React.createElement("text", {
    id: "Insurance_Papers_etc.",
    "data-name": "Insurance Papers, etc.",
    transform: "translate(10675.281 4316.496)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Insurance Papers, etc.")), /*#__PURE__*/React.createElement("text", {
    id: "Fact:_Many_spouses_are_unaware_of_the",
    "data-name": "Fact: Many spouses are unaware of the",
    transform: "translate(10675.281 4348.579)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fact: Many spouses are unaware of the")), /*#__PURE__*/React.createElement("text", {
    id: "location_of_stocks_bonds_or_other",
    "data-name": "location of stocks, bonds, or other",
    transform: "translate(10675.281 4371.912)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "location of stocks, bonds, or other")), /*#__PURE__*/React.createElement("text", {
    id: "investment_portfolios_of_their_mate_and",
    "data-name": "investment portfolios of their mate, and",
    transform: "translate(10675.281 4395.246)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "investment portfolios of their mate, and")), /*#__PURE__*/React.createElement("text", {
    id: "therefore_sometimes_never_gain_access",
    "data-name": "therefore sometimes never gain access",
    transform: "translate(10675.281 4418.579)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "therefore sometimes never gain access")), /*#__PURE__*/React.createElement("text", {
    id: "to_these_accounts_after_the_death_of",
    "data-name": "to these accounts after the death of",
    transform: "translate(10675.281 4441.912)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "to these accounts after the death of")), /*#__PURE__*/React.createElement("text", {
    id: "their_spouse.",
    "data-name": "their spouse.",
    transform: "translate(10675.281 4465.246)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "their spouse.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-17",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(10737 4195.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-6",
    x2: 271.6,
    transform: "translate(10747.55 3938.929) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-6",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(10754.149 4199.829) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Ability_to_record_the_purchase",
    "data-name": "Ability to record the purchase",
    transform: "translate(10770.271 3960.857)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ability to record the purchase")), /*#__PURE__*/React.createElement("text", {
    id: "price_and_estimated",
    "data-name": "price and estimated",
    transform: "translate(10770.271 3985.747)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "price and estimated")), /*#__PURE__*/React.createElement("text", {
    id: "replacement_values_of_home",
    "data-name": "replacement values of home",
    transform: "translate(10770.271 4010.636)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "replacement values of home")), /*#__PURE__*/React.createElement("text", {
    id: "inventory_items_as_well_as",
    "data-name": "inventory items, as well as",
    transform: "translate(10770.271 4035.524)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "inventory items, as well as")), /*#__PURE__*/React.createElement("text", {
    id: "uploading_a_video_or_pictures",
    "data-name": "uploading a video or pictures",
    transform: "translate(10770.271 4060.413)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "uploading a video or pictures")), /*#__PURE__*/React.createElement("text", {
    id: "of_the_items.",
    "data-name": "of the items.",
    transform: "translate(10770.271 4085.302)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of the items.")), /*#__PURE__*/React.createElement("text", {
    id: "Take_the_time_to_ask_your_insurance",
    "data-name": "Take the time to ask your insurance",
    transform: "translate(10770.271 4121.08)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Take the time to ask your insurance")), /*#__PURE__*/React.createElement("text", {
    id: "agent_how_valuable_this_is_and_how",
    "data-name": "agent how valuable this is, and how",
    transform: "translate(10770.271 4144.413)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "agent how valuable this is, and how")), /*#__PURE__*/React.createElement("text", {
    id: "quickly_it_can_be_used_to_settle_a_claim.",
    "data-name": "quickly it can be used to settle a claim.",
    transform: "translate(10770.271 4167.747)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "quickly it can be used to settle a claim.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-18",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(10956.399 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-7",
    y1: 288.1,
    transform: "translate(10966.899 4204.579)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-7",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(10960.3 4201.979)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Biographical_information_for",
    "data-name": "Biographical information for",
    transform: "translate(10990.192 4266.718)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Biographical information for")), /*#__PURE__*/React.createElement("text", {
    id: "Family_Members_and_Pets.",
    "data-name": "Family Members and Pets.",
    transform: "translate(10990.192 4291.606)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Family Members and Pets.")), /*#__PURE__*/React.createElement("text", {
    id: "Who_are_the_Pallberears_What_is_your",
    "data-name": "Who are the Pallberears? What is your",
    transform: "translate(10990.192 4327.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Who are the Pallberears? What is your")), /*#__PURE__*/React.createElement("text", {
    id: "spouses_complete_military_record_Who",
    "data-name": "spouses complete military record? Who",
    transform: "translate(10990.192 4350.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "spouses complete military record? Who")), /*#__PURE__*/React.createElement("text", {
    id: "do_you_notify_in_case_of_Death_When_did",
    "data-name": "do you notify in case of Death? When did",
    transform: "translate(10990.192 4374.052)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "do you notify in case of Death? When did")), /*#__PURE__*/React.createElement("text", {
    id: "they_graduate_college_What_is_your_Pets",
    "data-name": "they graduate college? What is your Pets",
    transform: "translate(10990.192 4397.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "they graduate college? What is your Pets")), /*#__PURE__*/React.createElement("text", {
    id: "Microchip_number_What_is_the_name_of",
    "data-name": "Microchip number? What is the name of",
    transform: "translate(10990.192 4420.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Microchip number? What is the name of")), /*#__PURE__*/React.createElement("text", {
    id: "your_pets_medication_What_special_diet",
    "data-name": "your pets medication? What special diet",
    transform: "translate(10990.192 4444.052)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "your pets medication? What special diet")), /*#__PURE__*/React.createElement("text", {
    id: "is_your_pet_on_It_s_all_saved_here_on_your",
    "data-name": "is your pet on? It\\u2019s all saved here on your",
    transform: "translate(10990.192 4467.385)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "is your pet on? It\u2019s all saved here on your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_Plan.",
    "data-name": "MYREDFOLDER\\xAE Plan.",
    transform: "translate(10990.192 4490.718)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE Plan.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-19",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(11097.396 4197.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-8",
    x2: 285.3,
    transform: "translate(11107.926 3926.4) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-8",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(11114.525 4201.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "What_about_Grandma_s_Medicine:",
    "data-name": "What about Grandma\\u2019s Medicine:",
    transform: "translate(11131.317 3948.412)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "What about Grandma\u2019s Medicine:")), /*#__PURE__*/React.createElement("text", {
    id: "During_a_major_disaster_scenario_it_is_quite_likely_that",
    "data-name": "During a major disaster scenario it is quite likely that",
    transform: "translate(11131.317 3977.957)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "During a major disaster scenario it is quite likely that")), /*#__PURE__*/React.createElement("text", {
    id: "an_evacuation_will_happen_very_quickly_and_without",
    "data-name": "an evacuation will happen very quickly and without",
    transform: "translate(11131.317 4001.291)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "an evacuation will happen very quickly and without")), /*#__PURE__*/React.createElement("text", {
    id: "time_to_plan._Many_times_prescription_information_or",
    "data-name": "time to plan. Many times prescription information, or",
    transform: "translate(11131.317 4024.624)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "time to plan. Many times prescription information, or")), /*#__PURE__*/React.createElement("text", {
    id: "other_medical_information_is_left_behind._Your",
    "data-name": "other medical information is left behind. Your",
    transform: "translate(11131.317 4047.957)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "other medical information is left behind. Your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_plan_prevents_this_from_happening",
    "data-name": "MYREDFOLDER\\xAE plan prevents this from happening",
    transform: "translate(11131.317 4071.291)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE plan prevents this from happening")), /*#__PURE__*/React.createElement("text", {
    id: "as_you_will_have_immediate_access_to_medications",
    "data-name": "as you will have immediate access to medications",
    transform: "translate(11131.317 4094.624)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "as you will have immediate access to medications")), /*#__PURE__*/React.createElement("text", {
    id: "and_or_medical_conditions_for_family_members_as_well",
    "data-name": "and/or medical conditions for family members as well",
    transform: "translate(11131.317 4117.957)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and/or medical conditions for family members as well")), /*#__PURE__*/React.createElement("text", {
    id: "as_pets._The_ability_to_have_this_information_readily",
    "data-name": "as pets. The ability to have this information readily",
    transform: "translate(11131.317 4141.291)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "as pets. The ability to have this information readily")), /*#__PURE__*/React.createElement("text", {
    id: "available_for_the_pharmacy_is_critical.",
    "data-name": "available for the pharmacy is critical.",
    transform: "translate(11131.317 4164.624)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "available for the pharmacy is critical.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-20",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(11316.796 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-9",
    y1: 260.1,
    transform: "translate(11327.226 4204.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-9",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(11320.625 4202.029)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Digital_structural_analysis",
    "data-name": "Digital structural analysis",
    transform: "translate(11350.677 4266.718)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Digital structural analysis")), /*#__PURE__*/React.createElement("text", {
    id: "report_and_post-disaster",
    "data-name": "report and post-disaster",
    transform: "translate(11350.677 4291.606)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "report and post-disaster")), /*#__PURE__*/React.createElement("text", {
    id: "assessment_forms.",
    "data-name": "assessment forms.",
    transform: "translate(11350.677 4316.496)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "assessment forms.")), /*#__PURE__*/React.createElement("text", {
    id: "Your_insurance_agent_will_love_you._The",
    "data-name": "Your insurance agent will love you. The",
    transform: "translate(11350.677 4345.273)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your insurance agent will love you. The")), /*#__PURE__*/React.createElement("text", {
    id: "structual_analysis_report_is_like_an",
    "data-name": "structual analysis report is like an",
    transform: "translate(11350.677 4368.606)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "structual analysis report is like an")), /*#__PURE__*/React.createElement("text", {
    id: "appraisal_for_a_DISASTER._The_Structural",
    "data-name": "appraisal for a DISASTER. The Structural",
    transform: "translate(11350.677 4391.94)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "appraisal for a DISASTER. The Structural")), /*#__PURE__*/React.createElement("text", {
    id: "analysis_report_allows_you_to_record_all",
    "data-name": "analysis report allows you to record all",
    transform: "translate(11350.677 4415.273)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "analysis report allows you to record all")), /*#__PURE__*/React.createElement("text", {
    id: "damages_in_an_organized_fashion.",
    "data-name": "damages in an organized fashion.",
    transform: "translate(11350.677 4438.606)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "damages in an organized fashion.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-21",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(11549.304 4197.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-10",
    x2: 233.1,
    transform: "translate(11559.843 3978.599) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-10",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(11566.443 4201.099) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Store_your_Passports_",
    "data-name": "Store your Passports,",
    transform: "translate(11583.54 3989.634)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Store your Passports,")), /*#__PURE__*/React.createElement("text", {
    id: "Drivers_License_and",
    "data-name": "Drivers License, and",
    transform: "translate(11583.54 4014.523)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drivers License, and")), /*#__PURE__*/React.createElement("text", {
    id: "Other_ID_s.",
    "data-name": "Other ID\\u2019s.",
    transform: "translate(11583.54 4039.412)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Other ID\u2019s.")), /*#__PURE__*/React.createElement("text", {
    id: "Don_t_get_stuck_in_another_Country",
    "data-name": "Don\\u2019t get stuck in another Country",
    transform: "translate(11583.54 4067.401)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Don\u2019t get stuck in another Country")), /*#__PURE__*/React.createElement("text", {
    id: "without_verification_of_your_lost_or",
    "data-name": "without verification of your lost or",
    transform: "translate(11583.54 4090.735)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "without verification of your lost or")), /*#__PURE__*/React.createElement("text", {
    id: "stolen_documents._Nothing_to",
    "data-name": "stolen documents. Nothing to",
    transform: "translate(11583.54 4114.068)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "stolen documents. Nothing to")), /*#__PURE__*/React.createElement("text", {
    id: "worry_about:_its_all_part_of_your",
    "data-name": "worry about: its all part of your",
    transform: "translate(11583.54 4137.401)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "worry about: its all part of your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_Plan",
    "data-name": "MYREDFOLDER\\xAE Plan",
    transform: "translate(11583.54 4160.735)",
    fill: "#010101",
    fontSize: 14,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE Plan")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-22",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(11667.302 4198.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-11",
    y1: 174.6,
    transform: "translate(11677.742 4204.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 1.556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-11",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(11671.142 4202.029)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "The_MYREDFOLDER_Plan",
    "data-name": "The MYREDFOLDER\\xAE Plan",
    transform: "translate(11701.026 4266.719)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The MYREDFOLDER\xAE Plan")), /*#__PURE__*/React.createElement("text", {
    id: "and_APP_represent_only_two",
    "data-name": "and APP represent only two",
    transform: "translate(11701.026 4291.607)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and APP represent only two")), /*#__PURE__*/React.createElement("text", {
    id: "of_our_many_world_class",
    "data-name": "of our many world class",
    transform: "translate(11701.026 4316.497)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of our many world class")), /*#__PURE__*/React.createElement("text", {
    id: "products_and_services_that",
    "data-name": "products and services that",
    transform: "translate(11701.026 4341.386)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "products and services that")), /*#__PURE__*/React.createElement("text", {
    id: "our_company_provides.",
    "data-name": "our company provides.",
    transform: "translate(11701.026 4366.274)",
    fill: "#ff3535",
    fontSize: 18.66,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "our company provides.")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrfRoadmapMobile);
export default __webpack_public_path__ + "static/media/MRF_roadmap-mobile.d6762a2e57ba4d68cdd18b923861bd50.svg";
export { ForwardRef as ReactComponent };